import type { Board, TileKind } from './types';

export interface GameSnapshot {
  board: Board;
  movesLeft: number;
  secondsLeft?: number;
  score: number;
  collected: Partial<Record<TileKind, number>>;
  objectiveProgress: Record<string, number>;
  charges: Record<'mira' | 'piko' | 'brum', number>;
  status: 'playing' | 'won' | 'lost';
  cascade?: number;
  message?: string;
}

class GameEvents extends EventTarget {
  emit(snapshot: GameSnapshot): void {
    this.dispatchEvent(new CustomEvent<GameSnapshot>('snapshot', { detail: snapshot }));
  }

  command(name: 'mira' | 'piko' | 'brum' | 'restart' | 'end'): void {
    this.dispatchEvent(new CustomEvent('command', { detail: name }));
  }
}

export const gameEvents = new GameEvents();
